import { useDispatch, useSelector } from 'react-redux';
import { getValue } from '@Selectors';
import {
	changeSensorConfigurationSearchValue,
	changeSensorTypesFilter,
	changeDataSourceTypesFilter,
	changeSensorConfigurationPhysicalFilter,
} from '@Actions';

export const useConfigurationsSearch = () => {
	const dispatch = useDispatch();

	const {
		configurations: {
			searchValue,
			initialized,
			sensorTypes,
			dataSourceTypes,
		},
	} = useSelector(getValue);

	const changeSearchValue = (search: string): void => {
		dispatch(changeSensorConfigurationSearchValue(search));
	};

	const changePhysicalOrVirtual = (virtualOrPhysical: string): void => {
		dispatch(changeSensorConfigurationPhysicalFilter(virtualOrPhysical));
	};

	const changeSensorTypes = (sensorTypes: string[]) => {
		dispatch(changeSensorTypesFilter(sensorTypes));
	};

	const changeDataSourceTypes = (dataSourceTypes: string[]) => {
		dispatch(changeDataSourceTypesFilter(dataSourceTypes));
	};

	return {
		searchValue,
		changeSearchValue,
		initialized,
		changeSensorTypes,
		sensorTypes,
		dataSourceTypes,
		changeDataSourceTypes,
		changePhysicalOrVirtual,
	};
};
